import { cn } from "@/lib/utils";
import {
  LIST_ASSIGNEE_AVATAR_MAX,
  overflowCount,
  personInitials,
} from "../tag-pill-style";

export type ListAssignee = { userId: string; label: string };

/** Compact assignee chips for list rows — plan/29+35. */
export function AssigneeAvatars(props: {
  assignees: ListAssignee[];
  maxVisible?: number;
  className?: string;
}) {
  if (props.assignees.length === 0) {
    return <span className="text-[var(--color-muted)]">—</span>;
  }
  const max = props.maxVisible ?? LIST_ASSIGNEE_AVATAR_MAX;
  const visible = props.assignees.slice(0, max);
  const more = overflowCount(props.assignees.length, max);
  const allLabels = props.assignees.map((a) => a.label).join(", ");
  return (
    <div
      className={cn("flex items-center -space-x-1.5", props.className)}
      title={allLabels}
    >
      {visible.map((a) => (
        <span
          key={a.userId}
          className="inline-flex size-6 shrink-0 items-center justify-center rounded-full border border-[var(--color-border)] bg-[var(--color-background)] text-[9px] font-semibold text-[var(--color-foreground)]"
          title={a.label}
        >
          {personInitials(a.label)}
        </span>
      ))}
      {more > 0 ? (
        <span className="inline-flex size-6 shrink-0 items-center justify-center rounded-full border border-[var(--color-border)] bg-[var(--color-card)] text-[9px] font-medium text-[var(--color-muted)]">
          +{more}
        </span>
      ) : null}
    </div>
  );
}
